import type { IconSvgObject } from './types';

const CableIcon: IconSvgObject = [
  ["path", { d: "M6 14H4C2.89543 14 2 14.8954 2 16V19H8V16C8 14.8954 7.10457 14 6 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 14V6.5C5 4.567 6.567 3 8.5 3C10.433 3 12 4.567 12 6.5V17.5C12 19.433 13.567 21 15.5 21C17.433 21 19 19.433 19 17.5V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 5H16V8C16 9.10457 16.8954 10 18 10H20C21.1046 10 22 9.10457 22 8V5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17 5V3M21 3V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M3 21V19M7 19V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default CableIcon;
